<template>
  <div class="home-header">
    <van-image class="img" v-if="tenantImg" round :src="tenantImg" />
    <van-image
      v-else
      class="img"
      round
      src="@/assets/home/home-header/account.svg"
    />
    <div class="name" @click="$emit('chooseSchool')">
        <span>{{ tenantName }}</span>
        <img class="image-down" src="@/assets/arrow_down.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeHeader',
  props: ['tenantName','tenantImg'],
  data() {
    return {}
  }
};
</script>

<style lang="less" scope>
.home-header {
  padding: 0 0.2rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  display: flex;
  align-items: center;
  height: 1.3rem;
  box-sizing: border-box;
  .img {
    width: 0.8rem;
    height: 0.8rem;
    border: 0.04rem solid #403D51;
  }
  .name{
    padding-left: 0.25rem;
    display: flex;
    align-items: center;
    span{
      color: #fff;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      font-size: 0.3rem;
    }
    .image-down{
      width: 32px;
      height: 32px;
    }
  }
}
</style>